import React, { useState } from 'react';
import { OrderResponse } from '../../types';

interface OrderHistorySidebarProps {
    orders: OrderResponse[];
    tableName: string;
    isLoading: boolean;
    error: string | null;
    onConfirmOrder: (orderId: number) => Promise<void>;
    onServeOrder: (orderId: number) => Promise<void>;
    onCancelOrderItem?: (orderId: number, orderItemId: number) => Promise<void>;
}

const OrderHistorySidebar: React.FC<OrderHistorySidebarProps> = ({
    orders, tableName, isLoading, error, onConfirmOrder, onServeOrder, onCancelOrderItem,
}) => {
    const [pending, setPending] = useState<number | null>(null);
    const visibleOrders = orders.filter(order => order.status === 'NEW' || order.status === 'PROCESSING');
    const runAction = async (orderId: number, action: () => Promise<void>) => {
        if (pending !== null) return;
        setPending(orderId);
        try { await action(); } finally { setPending(null); }
    };

    return (
        <section aria-label={`${tableName} 주문 내역`} style={{ flex: 1, minHeight: 0, overflowY: 'auto', margin: '10px 0' }}>
            {isLoading ? <p>주문을 불러오는 중...</p> : error ? <p role="alert">{error}</p> : visibleOrders.length === 0 ? (
                <p style={{ color: '#64748b', textAlign: 'center' }}>대기 주문 없음</p>
            ) : visibleOrders.map(order => (
                <article key={order.orderId} style={{ border: '1px solid #dbeafe', borderRadius: 6, padding: 8, marginBottom: 8 }}>
                    <strong style={{ display: 'block', marginBottom: 6 }}>주문 #{order.orderNumber}</strong>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {order.orderItems.map((item, index) => (
                            <li key={item.orderItemId ?? index} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 0' }}>
                                <strong style={{ flex: 1, overflowWrap: 'anywhere' }}>{item.productName}</strong>
                                <span style={{ whiteSpace: 'nowrap' }}>{item.quantity}개</span>
                                {onCancelOrderItem && item.orderItemId != null && (
                                    <button type="button" disabled={pending !== null}
                                        aria-label={`${item.productName} 취소`}
                                        onClick={() => runAction(order.orderId, () => onCancelOrderItem(order.orderId, item.orderItemId!))}
                                        style={{ border: 0, color: '#b91c1c', background: '#fff1f2', padding: 4, cursor: 'pointer' }}>
                                        취소
                                    </button>
                                )}
                            </li>
                        ))}
                    </ul>
                    <button type="button" disabled={pending !== null}
                        onClick={() => runAction(order.orderId, () => order.status === 'NEW' ? onConfirmOrder(order.orderId) : onServeOrder(order.orderId))}
                        style={{ width: '100%', padding: '8px 4px', border: 0, borderRadius: 5, color: '#fff', background: order.status === 'NEW' ? '#2563eb' : '#15803d', cursor: 'pointer' }}>
                        {pending === order.orderId ? '저장 중...' : order.status === 'NEW' ? '주문확인' : '서빙완료'}
                    </button>
                </article>
            ))}
        </section>
    );
};

export default OrderHistorySidebar;
